export const publicCdnAssetUrl = "https://cdn.iventis.co.uk/iventis-assets";
